/**
 * Check if a key is a modifier key for opening in a new tab.
 *
 * @param {string} key - Keyboard key name (event.key).
 * @return {boolean}
 */
export function isNewTabModifierKey(key) {
  return key === 'Meta' || key === 'Alt' || key === 'Control';
}

/**
 * Check if a key is used to trigger buttons.
 *
 * @param {string} key - Keyboard key name (event.key).
 * @return {boolean}
 */
export function isButtonActivationKey(key) {
  return key === 'Enter' || key === ' ';
}
